import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import EnterOTP from "./pages/EnterOTP";
import Dashboard from "./pages/Dashboard";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check authentication status from localStorage
  useEffect(() => {
    const session = localStorage.getItem("session");
    setIsAuthenticated(!!session); // If session exists, set to true
  }, []);

  // Function to handle authentication changes (login, logout)
  const handleAuthentication = (status) => {
    if (status) {
      localStorage.setItem("session", "active");
    } else {
      localStorage.removeItem("session");
    }
    setIsAuthenticated(status);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" />
            ) : (
              <Login handleAuthentication={handleAuthentication} />
            )
          }
        />
        <Route
          path="/otp"
          element={<EnterOTP handleAuthentication={handleAuthentication} />}
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <Dashboard handleAuthentication={handleAuthentication} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
